<div class="calio-pc-container container-fluid">
  <div class="calio-pc-main-container ">
    @if (!resolving$() && activeStep$() !== 3 && activeStep$() !== 4 && activeStep$() !== 5 && registrationMode$() !== registrationMode.SLG) {
      <div class="stepper-container d-flex align-items-center left-container pb-0 mt-3">
        <div class="progress" [attr.data-percentage]="activeStep$() === 1 ? 50 : 100">
          <span class="progress-left">
            <span class="progress-bar"></span>
          </span>
          <span class="progress-right">
            <span class="progress-bar"></span>
          </span>
        </div>
        <div class="ms-3 stepper-font">
          {{ 'create_partner_component.step_count' | translate : {'step': activeStep$() ,'totalSteps': 2} }}
        </div>
      </div>
    }

    <div class="left-container col-12 col-md-1">
      @defer (on viewport) {
        @if (activeStep$() === 1) {
          <div class="calio-pc-heading">
            {{ 'create_partner_component.heading_1' | translate }}
            <br>
            {{ 'create_partner_component.heading_2' | translate }}
          </div>
          <div class="calio-pc-subtitle">
            {{ 'create_partner_component.subtitle' | translate }}
          </div>
        } @else if (activeStep$() === 2) {
          <div class="calio-pc-heading">
            @if (registrationMode$() === registrationMode.SLG) {
              {{ 'create_partner_component.heading_1' | translate }}
              <br>
              {{ 'create_partner_component.heading_2' | translate }}
            } @else {
              {{ 'create_partner_component.step_2_heading' | translate }}
            }
          </div>
          <div class="calio-pc-subtitle">
            @if (registrationMode$() === registrationMode.SLG) {
              {{ 'create_partner_component.subtitle' | translate }}
            } @else {
              {{ 'create_partner_component.step_2_subtitle' | translate }}
            }
          </div>
        }
      } @placeholder {
        <div></div>
      }

      @if (warningDescriptionText$()) {
        <div class="card bg-white shadow rounded card-box mb-5">
          <div class="card-body">
            <div class="d-flex">
              <div class="text-center icon-block">
                <div class="notification-icon">
                  <img src="/assets/images/notifications/warning_ico.svg" />
                </div>
              </div>
              <div class="content-block">
                <div class="notification-title text-warning">
                  {{ 'error_messages.' + warningTitleText$() | translate }}
                </div>
                <div class="notification-description pt-2">
                  {{ 'error_messages.' + warningDescriptionText$() | translate }}
                </div>
              </div>
            </div>
          </div>
        </div>
      }

      @if (errorText$()) {
        <div class="card bg-white shadow rounded card-box mb-5">
          <div class="card-body">
            <div class="d-flex">
              <div class="text-center icon-block">
                <div class="notification-icon">
                  <img src="/assets/images/notifications/problem_ico.svg" />
                </div>
              </div>
              <div class="content-block">
                <div class="notification-title text-problem">
                  {{ 'error_messages.error_title' | translate }}
                </div>
                <div class="notification-description pt-2">
                  {{ 'error_messages.' + errorText$() | translate }}
                </div>
              </div>
            </div>
          </div>
        </div>
      }

      <!--
        NOTE: ui-mode="reseller" is an unimplemented stub. These two gates
        suppress steps 1 & 2 when it is set, but there is no reseller-specific
        body, so setting ui-mode="reseller" renders an empty wizard. It is
        never activated in production (only a commented-out attribute in
        index*.html). Kept as a placeholder for a future reseller flow --
        do not rely on it, and don't build against it until a body exists.
      -->
      @if (resolving$()) {
        <div class="creating-account-loader">
          <div class="lds-ring">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
      } @else if (isSubmittingPartner$()) {
        <div class="creating-account-loader">
          <div class="lds-ring">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
          <div class="creating-account-text">{{ 'create_partner_component.creating_account' | translate }}</div>
        </div>
      } @else if (activeStep$() === 1 && uiMode$() !== 'reseller') {
        @defer {
          <app-email-step
            [emailFormError]="emailFormError$()"
            [prefillEmail]="partnerFormModel.email"
            (onNextEvent)="saveEmail($event)"
          />
        }
      } @else if (activeStep$() === 2 && uiMode$() !== 'reseller') {
          @defer {
            <app-personal-data-step
              email="{{ this.partnerFormModel.email }}"
              [personalFormError]="personalFormError$()"
              [registrationMode]="registrationMode$()"
              [mobileRequired]="mobileRequired$()"
              [prefill]="partnerFormModel"
              (onNextEvent)="submitPartnerData($event)"
            />
          }
      } @else if (activeStep$() === 3) {
          @defer {
            <app-final-step [partner]="partner" [registrationMode]="registrationMode$()" [emailOtpVerified]="emailOtpVerified" />
          }
      } @else if (activeStep$() === 4) {
          @defer {
            <app-otp-step
              [mobile]="otpMobile$()"
              [verificationStep]="smsOtpStep()"
              [verificationTotal]="otpTotal()"
              (onNextEvent)="onOtpVerified()"
              (onEditContact)="onEditContact('mobile')"
            />
          }
      } @else if (activeStep$() === 5) {
          @defer {
            <app-email-otp-step
              [email]="otpEmail$()"
              [verificationStep]="1"
              [verificationTotal]="otpTotal()"
              (onNextEvent)="onEmailOtpVerified()"
              (onEditContact)="onEditContact('email')"
            />
          }
      }
    </div>
  </div>
</div>